<template>
  <div>
    school_teacher_statistics
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
</style>